export function cleanHtmlString (str: string): string {
  return str.replace(/<\/?[^>]+(>|$)/g, "")
}

// // Example usage:
// let stringWithHTML = "<p>This is <em>an</em> example <strong>string</strong> with <a href='#'>HTML</a> tags.</p>"
// let cleanString = cleanHtmlString(stringWithHTML)
// console.log(cleanString) // Output: "This is an example string with HTML tags."
